import { Injectable } from '@angular/core'
import { DialogService } from '@tokeet-frontend/tv3-platform'
import { AiChatOverlayComponent } from './ai-chat-overlay.component'

@Injectable()
export class AIChatOverlayService {
  constructor(private dialog: DialogService) {}

  public open() {
    return this.dialog.openDrawer(AiChatOverlayComponent, {
      panelClass: 'drawer-full-60',
    })
  }
}
